export default __webpack_public_path__ + "85555dcca6407fc081f70a97434b51ae.png";